<template>
	<div id="histogram-selector" v-if="activeScopeType.value == 'histogram'">
		<v-menu :content-class="'account-menu--theme --app'" min-width="200" offset-y nudge-bottom="15">
			<template v-slot:activator="{ on, attrs }">
				<div class="histogram-type-label" v-bind="attrs" v-on="on">
					<span class="name">{{ activeType.text }}</span>
					<i class="material-icons">expand_more</i>
				</div>
			</template>

			<div class="account-menu-content histogram-types-menu-content">
				<v-list>
					<v-list-item
						v-for="type in histogramTypes"
						:key="type.value"
						@click="onTypeSelection(type)"
						:class="{ '--selected': type.value == activeType.value }"
					>
						<span>{{ type.text }}</span>
					</v-list-item>
				</v-list>
			</div>
		</v-menu>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	data() {
		return {
			activeType: {},
		};
	},

	created() {
		this.activeType = this.$store.state.Scopes.activeHistogramType;
	},

	computed: {
		...mapState("Scopes", ["histogramTypes", "activeScopeType"]),
	},

	methods: {
		onTypeSelection(type) {
			this.activeType = type;
			window.histogram.type = type.value;
			window.gpu.render();
		},
	},
};
</script>

<style lang="scss">
.histogram-type-label {
	display: flex;
	align-items: center;
	margin-right: 20px;
	> span {
		font-size: 0.9rem;
		font-weight: bold;
	}

	> i {
		font-size: 18px;
	}
}

.histogram-types-menu-content {
	.v-list-item {
		min-height: 20px !important;
	}

	span {
		color: var(--font-default-color);
		font-size: 0.9rem;
		list-style: 1.2rem;
	}

	.--selected {
		span {
			color: var(--primary);
		}
	}
}
</style>
